namespace $.$$ {

	export class $shm_dashboard_admin_users extends $.$shm_dashboard_admin_users {

		admin_authenticated() {
			return this.$.$shm_pb.admin_authenticated()
		}

		admin_token_present() {
			return Boolean( this.$.$shm_pb.admin_auth_token() )
		}

		users() {
			if( !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.admin_records_all_realtime( 'users\n\nemail' )
		}

		filtered_users() {
			const needle = this.filter().trim().toLocaleLowerCase()
			if( !needle ) return this.users()
			return this.users().filter( user => [ user.id, user.email, user.name, user.username ]
				.some( value => String( value || '' ).toLocaleLowerCase().includes( needle ) ) )
		}

		selected_user_id( next?: string ) {
			if( next !== undefined ) return super.selected_user_id( next )
			return super.selected_user_id()
		}

		user_pages() {
			return [
				this.Users_page(),
				this.add_opened() ? this.User_add() : this.selected_user_id() ? this.Dashboards() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		user_add( next?: Event ) {
			if( next !== undefined ) {
				this.selected_user_id( '' )
				this.add_opened( true )
			}
			return next ?? null
		}

		user_created( next?: string ) {
			if( next ) {
				this.add_opened( false )
				this.selected_user_id( next )
			}
			return next ?? ''
		}

		body_rows() {
			const users = this.filtered_users()
			if( !users.length ) return [ this.Empty() ]
			return [ this.Table_head(), ... users.map( user => this.Row( user.id ) ) ]
		}

		empty_message() {
			return this.admin_token_present()
				? 'Пользователей нет'
				: 'Нужно войти в superuser'
		}

		user_pick( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.selected_user_id( id )
			this.add_opened( false )
			return next
		}

		user_current( id: string ) {
			return id === this.selected_user_id()
		}

		user( id: string ) {
			return this.users().find( user => user.id === id ) ?? null
		}

		user_email( id: string ) {
			return String( this.user( id )?.email ?? '' )
		}

		user_name( id: string ) {
			return String( this.user( id )?.name ?? this.user( id )?.username ?? '' )
		}

		user_created_at( id: string ) {
			const created = String( this.user( id )?.created ?? '' )
			if( !created ) return ''

			const date = new Date( created )
			if( Number.isNaN( date.getTime() ) ) return created
			return date.toLocaleString( 'ru-RU' )
		}

		user_id( id: string ) {
			return id
		}

	}

}
